module.exports = __webpack_public_path__ + "images/emoji/page_facing_up.6c8d8be4f7b9e523f5d8.png";